import "./Support.css";

import type { FC, ReactNode } from "react";

export type Messenger = {
  url: string;
  icon: ReactNode;
};

export type SupportProps = {
  title: string;
  subtitle?: string;
  messengers: Array<Messenger>;
};
/**
 * @deprecated
 */
export const Support: FC<SupportProps> = (props) => {
  return (
    <div className="section-content support" id="support">
      <h2>{props.title}</h2>
      <div className="messengers">
        {props.messengers.map((item, index) => (
          <a href={item.url} key={index}>
            {item.icon}
          </a>
        ))}
      </div>
      <div className="support-subtitle">{props.subtitle}</div>
    </div>
  );
};
